import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql, compose } from 'react-apollo'
import { message } from 'antd'
import { setUIState, containerIds } from 'modules/ui'
import { setCompany } from 'modules/company'
import { setUser } from 'modules/user'
import {
  companyFragment,
  signupViewerFragment,
  userErrorsFragment,
} from 'fragments'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Path from 'routes/path'
import PopupWrapper from 'components/atoms/PopupWrapper'
import BusinessLayout from 'components/layouts/BusinessLayout/home'
import SignupForm from 'components/business/SignupForm'
import PaidForm from 'components/business/PaidForm'
import queryString from 'query-string'
import SMConst from 'frontend_core/dist/constants/sm-const'
import { wwwUrl, businessUrl } from 'frontend_core/dist/helpers/url'
import ConfirmRegisterPopup from 'components/business/ConfirmRegisterPopup'
import SavedPopup from 'components/business/SavedPopup'
import PaidExaminationPopup from 'components/business/PaidExaminationPopup'

class SignupContainer extends Component<*> {
  componentDidMount() {
    const { data, actions } = this.props
    const currentUser = data.viewer
    if (currentUser) {
      actions.setUIState(containerIds.BUSINESS_SIGNUP, {
        validUserForm: true,
      })
      actions.setUser({
        email: currentUser.email,
        username: currentUser.username,
        familyName: (currentUser.contact || {}).familyName || '',
        givenName: (currentUser.contact || {}).givenName || '',
      })
    }
  }
  componentDidUpdate() {
    if (window.componentHandler) {
      window.componentHandler.upgradeDom()
    }
  }

  generateCreateCompanyInputParams = () => {
    const { ui, user } = this.props
    const paidForm = ui.paidForm || {}

    return {
      user: {
        familyName: user.familyName,
        givenName: user.givenName,
        email: user.email,
        password: user.password,
        passwordConfirmation: user.passwordConfirmation,
      },
      company: {
        name: paidForm.corpName,
        tel: paidForm.tel,
        email: paidForm.email,
        postalCode: paidForm.postalCode,
        state: paidForm.state,
        city: paidForm.city,
        address1: paidForm.address1,
        address2: paidForm.address2,
        businessTaxId: paidForm.businessTaxId,
        paymentMethod: paidForm.paymentMethod,
        corpNameKana: paidForm.corpNameKana,
        ceoFamilyName: paidForm.ceoFamilyName,
        ceoGivenName: paidForm.ceoGivenName,
        ceoFamilyNameKana: paidForm.ceoFamilyNameKana,
        ceoGivenNameKana: paidForm.ceoGivenNameKana,
        contactPersonFamilyName: paidForm.contactPersonFamilyName,
        contactPersonGivenName: paidForm.contactPersonGivenName,
        contactPersonFamilyNameKana: paidForm.contactPersonFamilyNameKana,
        contactPersonGivenNameKana: paidForm.contactPersonGivenNameKana,
      },
    }
  }

  createCompanyValidate = async (resourceType: 'User' | 'Company') => {
    const { user, actions, data, createCompanyValidate, history } = this.props
    const currentUser = data.viewer

    const input = this.generateCreateCompanyInputParams()
    try {
      actions.setUIState(containerIds.BUSINESS_SIGNUP, {
        mutateLoading: true,
      })

      const res = await createCompanyValidate(input)
      let userErrors = res.data.createCompanyValidate.userErrors || []
      if (resourceType === 'User') {
        userErrors = userErrors.filter(e => e.resource === resourceType)
      }
      if (userErrors.length) {
        message.warning(i18n.t('page.shared.inputInformationIncomplete'))
        actions.setUIState(containerIds.BUSINESS_SIGNUP, {
          errors: userErrors,
        })
      } else {
        actions.setUIState(containerIds.BUSINESS_SIGNUP, {
          errors: [],
        })
        switch (resourceType) {
          case 'User':
            actions.setUIState(containerIds.BUSINESS_SIGNUP, {
              validUserForm: true,
              paidForm: {
                paymentMethod: SMConst.PaymentMethod.Card,
              },
            })
            history.push(Path.signupCompanyForm())
            break
          case 'Company':
            actions.setUIState(containerIds.BUSINESS_SIGNUP, {
              validPaidForm: true,
              isShowingConfirm: true,
            })
            history.push(Path.signupConfirmCompanyForm())
            break
          default:
            break
        }
      }
    } catch (e) {
      message.warning(i18n.t('error.500.title'))
    } finally {
      actions.setUIState(containerIds.BUSINESS_SIGNUP, {
        mutateLoading: false,
      })
    }
  }

  createCompany = async () => {
    const { user, actions, data, createCompany, history } = this.props

    const input = this.generateCreateCompanyInputParams()
    try {
      actions.setUIState(containerIds.BUSINESS_SIGNUP, {
        mutateLoading: true,
      })

      const res = await createCompany(input)
      const userErrors = res.data.createCompany.userErrors || []
      if (userErrors.length) {
        message.warning(i18n.t('page.shared.inputInformationIncomplete'))
        actions.setUIState(containerIds.BUSINESS_SIGNUP, {
          errors: userErrors,
        })
      } else {
        actions.setUIState(containerIds.BUSINESS_SIGNUP, {
          isSuccessRegister: true,
        })
      }
    } catch (e) {
      message.warning(i18n.t('error.500.title'))
    } finally {
      actions.setUIState(containerIds.BUSINESS_SIGNUP, {
        mutateLoading: false,
      })
    }
  }

  render() {
    const { ui, user, history, location, data, actions } = this.props
    const currentUser = data.viewer
    const paidForm = ui.paidForm || {}
    const query = queryString.parse(location.search)
    const isShowingUserForm = location.pathname === Path.signup()
    const isShowingPaidForm = location.pathname === Path.signupCompanyForm()
    const isShowingConfirm =
      location.pathname === Path.signupConfirmCompanyForm() &&
      !ui.isSuccessRegister
    const isShowingPaidExaminationPopup =
      ui.isSuccessRegister &&
      paidForm.paymentMethod === SMConst.PaymentMethod.Paid
    const isShowingSavedPopup =
      ui.isSuccessRegister &&
      paidForm.paymentMethod !== SMConst.PaymentMethod.Paid

    if (isShowingUserForm && currentUser && ui.validUserForm) {
      return <Redirect to={Path.signupCompanyForm()} />
    }

    if (isShowingPaidForm && !ui.validUserForm) {
      return <Redirect to={Path.signup()} />
    }

    if (isShowingConfirm && !ui.validPaidForm) {
      return <Redirect to={Path.signupCompanyForm()} />
    }

    return (
      <BusinessLayout
        title={i18n.t('server.business.signup.title')}
        description={i18n.t('server.business.signup.description')}
        {...this.props}
      >
        <div className="site-main site-business__main">
          <div className="page__even lp-page__padding">
            <div className="page__col1">
              <div className="signup-head">
                <h1 className="page-title">法人アカウント登録</h1>
                {currentUser ? (
                  <ul className="signup-step mb20">
                    <li
                      className={`signup-step__status1 business-signup-step__status2 ${
                        isShowingPaidForm ? 'is-current' : ''
                      }`}
                    >
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status3">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li className="signup-step__status2">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                ) : (
                  <ul className="signup-step business-signup__step mb20">
                    <li
                      className={`signup-step__status1 ${
                        isShowingPaidForm ? '' : 'is-current'
                      }`}
                    >
                      <span className="sm-hide">アカウント</span>登録
                    </li>
                    <li className="signup-step__status3">
                      <span className="sm-hide">登録</span>完了
                    </li>
                    <li
                      className={`signup-step__status2 business-signup-step__status2 ${
                        isShowingPaidForm ? 'is-current' : ''
                      }`}
                    >
                      <span className="sm-hide">法人情報</span>入力
                    </li>
                    <li className="signup-step__status2">
                      <span className="sm-hide">メールアドレスの</span>確認
                    </li>
                  </ul>
                )}
              </div>

              <SignupForm
                {...this.props}
                isShow={isShowingUserForm}
                validateUserSignup={() => this.createCompanyValidate('User')}
              />
              <PaidForm
                {...this.props}
                isShow={isShowingPaidForm}
                validateCreateCompany={() =>
                  this.createCompanyValidate('Company')
                }
              />

              {!currentUser &&
                !isShowingPaidForm && (
                  <div className="signup-box">
                    <div className="row">
                      <div className="col-xs-12 ta-c">
                        <h2 className="signup-box__title signup-box__title-other">
                          すでにアカウントをお持ちの方
                        </h2>
                        <a
                          href={Path.loginAccount(this.props.config.URL || '')}
                          className="button-green pt15 pb15 w200 sm-w100"
                        >
                          ログイン
                        </a>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
        {isShowingConfirm && (
          <PopupWrapper>
            <div className="site-main site-business__main">
              <ConfirmRegisterPopup
                {...this.props}
                paidForm={ui.paidForm || {}}
                stateText={ui.stateText}
                onClickBack={() => history.goBack()}
                onClickRegister={this.createCompany}
              />
            </div>
          </PopupWrapper>
        )}
        {isShowingPaidExaminationPopup && (
          <PopupWrapper>
            <PaidExaminationPopup
              onClickBack={() => history.push(Path.signupDone())}
              onClickContinue={() => history.push(Path.signupDone())}
            />
          </PopupWrapper>
        )}
        {isShowingSavedPopup && (
          <PopupWrapper>
            <SavedPopup
              onClickBack={() => history.push(Path.signupDone())}
              onClickContinue={() => history.push(Path.signupDone())}
            />
          </PopupWrapper>
        )}
      </BusinessLayout>
    )
  }
}

const createCompanyValidate = gql`
  mutation createCompanyValidate($input: CreateCompanyValidateInput!) {
    createCompanyValidate(input: $input) {
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const createCompany = gql`
  mutation createCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
      createdCompanyUsername
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const withMutation = compose(
  graphql(createCompany, {
    props: ({ mutate }) => ({
      createCompany: input => mutate({ variables: { input } }),
    }),
  }),
  graphql(createCompanyValidate, {
    props: ({ mutate }) => ({
      createCompanyValidate: input => mutate({ variables: { input } }),
    }),
  }),
)(SignupContainer)

const withData = graphql(
  gql`
  query BusinessSignupContainer {
    viewer {
      ${signupViewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {},
    }),
  },
)(withMutation)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState, setCompany, setUser }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)
